import { Component, effect, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { User } from './core/user/user.types';
import { UserService } from './core/user/user.service';
import {
	AngularPlugin,
	IErrorService,
} from '@microsoft/applicationinsights-angularplugin-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

@Component({
	selector: 'cm-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	imports: [RouterOutlet],
})
export class AppComponent {
	/**
	 * Constructor
	 */
	constructor(private userService: UserService, private router: Router) {
		effect(() => {
			const user = this.userService.userSig$();
			if (user) {
				this.addAppInsights(user);
			}
		});
	}

	addAppInsights(user: User) {
		var angularPlugin = new AngularPlugin();

		const appInsights = new ApplicationInsights({
			config: {
				connectionString: environment.appInsightsConnectionString,
				extensions: [<any>angularPlugin],
				extensionConfig: {
					[angularPlugin.identifier]: {
						router: this.router,
						errorServices: [new CustomErrorHandler()],
					},
				},
			},
		});

		appInsights.loadAppInsights();

		if (user?.email) {
			appInsights.setAuthenticatedUserContext(
				user.email,
				user.id.toString(),
				false
			);
		}
	}
}

export class CustomErrorHandler implements IErrorService {
	private readonly _userService = inject(UserService);

	isAdmin$ = this._userService.isAdmin;

	handleError(error: any) {
		if (error && (!environment.production || this.isAdmin$())) {
			console.error(error);
		}
	}
}
